// extracted by mini-css-extract-plugin
export default {"box":"SliderNote_box__x4HR9","positionLeft":"SliderNote_positionLeft__wrtOy","positionRight":"SliderNote_positionRight__G193S","btn":"SliderNote_btn__4zc-U"};